import React from "react";

export default function Logo({ collapsed = false, light = false }) {
  return (
    <div className="flex items-center gap-2.5">
      <div className="flex h-9 w-9 items-center justify-center rounded-xl gradient-brand shadow-brand">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L3 7l9 5 9-5-9-5z" fill="#fff" fillOpacity="0.95" />
          <path d="M3 12l9 5 9-5M3 17l9 5 9-5" stroke="#fff" strokeOpacity="0.7" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      {!collapsed && (
        <div className="leading-tight">
          <p className={`font-heading text-[15px] font-extrabold tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
            AWebBee
          </p>
          <p className={`text-[10px] font-semibold uppercase tracking-[0.15em] ${light ? "text-white/60" : "text-brand-500"}`}>
            GMB Manager
          </p>
        </div>
      )}
    </div>
  );
}
